import { Outlet } from 'react-router-dom';

export const SinglePane = () => <Outlet />;
